import { render, staticRenderFns } from "./AdvanceModHistory.vue?vue&type=template&id=52586ddb&"
import script from "./AdvanceModHistory.vue?vue&type=script&lang=js&"
export * from "./AdvanceModHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports